import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'

// components
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { useOktaAuth } from '@okta/okta-react';

// UI Toolkit
import { NavigationBarDesktop, NavigationBarMobile } from '@xiam/xiam-ui-toolkit'
import '@xiam/xiam-ui-toolkit/dist/xiam-ui-toolkit.css';

import AppRoutes from '../../routes';

// store
import { getUserObject, getUserCallStatus } from '../../store/selectors/userProfile';

// hooks
import { useIsMobileView } from '../../utils/isMobileView';

// actions
import { fetchUser } from '../../store/actions/userProfile'

// helpers
import { getUserId } from '../../helpers/user';
import { getFirstName, getLastName, getLastLogin } from '../../helpers/users';
import { removeEmptyProperties } from '../../helpers/general'

import '../../utils/i18n'
import styles from './NavigationBar.module.scss'
import logo from '../../assets/jj_red_logo.svg';
import logoMobile from '../../assets/jj_red_logo_mobile.svg'
import { BANNER_MENU_SECTIONS, BANNER_DROPDOWN_MENU_SECTIONS, HAMBURGER_MENU_SECTIONS } from '../../utils/config'

function Content() {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const userData = useSelector(getUserObject)
  const dataLoaded = useSelector(getUserCallStatus)
  const { authState } = useOktaAuth() || {};
  const isMobileView = useIsMobileView()

  const getUser = async (id) => {
      try {
        if (Object.keys(removeEmptyProperties(userData))?.length > 0) return
        await dispatch(fetchUser(id)).unwrap()
      } catch (error) {
        // toast.error(error.message)
      }
    }
    useEffect(() => {
      const userId = getUserId()
      if (dataLoaded === 'loading') return
      getUser(userId)
    }, [])

  const userInfo = {
    profilePictureData: '',
    firstName: getFirstName(userData),
    lastName: getLastName(userData),
    lastLogin: getLastLogin(userData),
  }

  useEffect(() => {
    const preferredLang = userData?.preferredLanguage
    if (Array.isArray(i18n.resourceKeys) && i18n.resourceKeys.includes(preferredLang)) {
      i18n.changeLanguage(preferredLang)
    }
  }, [userData])

  return (
    <Box sx={{ display: 'flex' }}>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        sx={
          authState?.isAuthenticated ? '' : { mt: '65px' }
        }
      >
        {authState?.isAuthenticated && !isMobileView && (
          <NavigationBarDesktop
            logo={logo}
            dropdownMenuLinks={BANNER_DROPDOWN_MENU_SECTIONS}
            errorBar
            links={BANNER_MENU_SECTIONS}
            showUserProfile
            userInfo={userInfo}
            key="menu"
            customStyle={styles}
            secondLogo="Access Manager"
          />
        )}
        {authState?.isAuthenticated && isMobileView && (
          <NavigationBarMobile
            logo={logoMobile}
            hamburguerMenuLinks={HAMBURGER_MENU_SECTIONS}
            errorBar
            links={BANNER_MENU_SECTIONS}
            showUserProfile
            userInfo={userInfo}
            key="menu"
            customStyle={styles}
            secondLogo="Access Manager"
          />
        )}
        <AppRoutes />
      </Grid>
    </Box>
  )
}
export default Content
